import { http } from '@/core/helpers/http.helper';
import { Activity } from '@/core/collections/activities/activity.interface';
import { ApiResource } from '@/core/models/api-resource.interface';

import { LocationQuery } from 'vue-router';

export class ActivityService {
   async getActivities(candidateId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Activity>>>(`/candidates/${candidateId}/activities`, { params: { ...query } });
      return response.data;
   }
}
